"use client"

import { useState, useEffect } from "react"
import { setStorage, getStorage, deleteStorage } from "../modals/Storage"
import { API_ACCESS_URL, AVATARS_ARR, getRandomInt, openNewPage } from "../modals/Constants"
import { Link, useNavigate } from "react-router-dom"
import BottomNavbar from "../other-components/BottomNavbar/Navbar"
import NoticeDialog from "../dialogs/NoticeDialog2"
import SlideShow from "../other-components/SlideShow"
import styles from "../css/Screens.module.css"
import general from "../css/General.module.css"
import ImportantNotice from "../other-components/ImportantNotice/Notice"
import { getSessionStorage, setSessionStorage } from "../modals/Session"

// Custom CSS for the popup
const customPopupStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    maxWidth: "300px",
    width: "90%",
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 1001,
    position: "relative",
  },
  header: {
    marginBottom: "15px",
    textAlign: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  description: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  cancelButton: {
    padding: "8px 16px",
    backgroundColor: "#f1f1f1",
    color: "#333",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  },
  confirmButton: {
    padding: "8px 16px",
    backgroundColor: "#4f46e5",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  },
}

function Home() {
  const navigate = useNavigate()
  const [isLoadingShow, setLoadingShow] = useState(false)
  const [viewBoxNumber, setViewBoxNumber] = useState(0)
  const [isGameLoading, setIsGameLoading] = useState(false)
  const [loadingGameName, setLoadingGameName] = useState("")

  // Add state for the confirmation dialog
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    gameId: "",
    gameName: "",
  })

  const [pageConst, setConstants] = useState({
    accountId: "",
    accountBalance: 0,
    isDataLoaded: false,
    recordList: [],
    sliderImages: [],
    winnersRecordList: [],
  })

  const [noticeDialogConst, setNoticeDialogConst] = useState({
    noticeTitle: "",
    noticeNote: "",
    noticeDialogShow: false,
  })

  const refreshData = () => {
    setConstants((previousState) => {
      return { ...previousState, isDataLoaded: false }
    })
  }

  const updateSliderImagesArr = (data) => {
    if (data.length > 0) {
      setConstants((previousState) => {
        return { ...previousState, sliderImages: data }
      })
    }
  }

  const [toastDialogConst, setToastDialogConst] = useState({
    toastDialogShow: false,
    toastDialogMode: 1,
    toastMessage: "",
  })

  const updateToastDialogState = (data, mode, msg) => {
    // mode: 1 / success
    // mode: 2 / warning

    setToastDialogConst((previousState) => {
      return { ...previousState, toastDialogShow: data }
    })

    setToastDialogConst((previousState) => {
      return { ...previousState, toastDialogMode: mode }
    })

    setToastDialogConst((previousState) => {
      return { ...previousState, toastMessage: msg }
    })
  }

  // Check if game is already open
  const isGameAlreadyOpen = (gameId) => {
    const openGames = getSessionStorage("openGames") ? JSON.parse(getSessionStorage("openGames")) : {}
    return openGames[gameId]
  }

  // Update the session storage when a game is opened
  const markGameAsOpen = (gameId) => {
    const openGames = getSessionStorage("openGames") ? JSON.parse(getSessionStorage("openGames")) : {}
    openGames[gameId] = true
    setSessionStorage("openGames", JSON.stringify(openGames))
  }

  // Update the confirmGameOpen function to check for a minimum balance of 100 Rs
  // Replace the existing confirmGameOpen function with this updated version:

  const confirmGameOpen = (gameId, gameName = "Huidu") => {
    // Check if user is logged in
    if (!getStorage("uid")) {
      updateToastDialogState(true, 2, "You are not logged in")

      // Auto-hide toast after 3 seconds
      setTimeout(() => {
        updateToastDialogState(false, 2, "")
      }, 3000)

      return
    }

    // Check if balance is sufficient (at least 100 Rs)
    const balance = Number.parseFloat(getStorage("balance") || "0")
    if (balance < 0) {
      updateToastDialogState(true, 2, "You need at least 100 Rs balance to play this game")

      // Auto-hide toast after 3 seconds
      setTimeout(() => {
        updateToastDialogState(false, 2, "")
      }, 3000)

      return
    }

    setConfirmDialog({
      isOpen: true,
      gameId,
      gameName,
    })
  }

  // Add the closeConfirmDialog function after the confirmGameOpen function:

  const closeConfirmDialog = () => {
    setConfirmDialog({
      isOpen: false,
      gameId: "",
      gameName: "",
    })
  }

  // Also update the proceedWithGameOpen function to have the same balance check:

  const proceedWithGameOpen = () => {
    // Check if user is logged in
    if (!getStorage("uid")) {
      updateToastDialogState(true, 2, "You are not logged in")

      // Auto-hide toast after 3 seconds
      setTimeout(() => {
        updateToastDialogState(false, 2, "")
      }, 3000)

      closeConfirmDialog()
      return
    }

    // Check if user has sufficient balance (at least 100 Rs)
    const balance = Number.parseFloat(getStorage("balance") || "0")
    if (balance < 0) {
      updateToastDialogState(true, 2, "You need at least 100 Rs balance to play this game")

      // Auto-hide toast after 3 seconds
      setTimeout(() => {
        updateToastDialogState(false, 2, "")
      }, 3000)

      closeConfirmDialog()
      return
    }

    setIsGameLoading(true)
    setLoadingGameName(confirmDialog.gameName)
    handleImageClick(confirmDialog.gameId, confirmDialog.gameName)
    closeConfirmDialog()
  }

  // Original handleImageClick function
  const handleImageClick = async (gameId, gameName = "Huidu") => {
    var userId = getStorage("uid")

    setIsGameLoading(true)
    setLoadingGameName(gameName)
    // showToast(2, "Data Created Successfully! \n Redirecting You!")
    try {
      const response = await fetch("https://api.leo99.space/router/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          route: "route-play-games",
          AuthToken: getStorage("secret"),
        },
        body: JSON.stringify({
          USER_ID: userId,
          GAME_NAME: gameName,
          GAME_UID: gameId,
        }),
      })

      if (!response.ok) {
        throw new Error("Network response was not ok")
      }

      const data = await response.json()

      if (data.error) {
        console.error("Error:", data.status_code)
        alert(`Error: ${data.status_code}`)
      } else if (data.data?.game_url) {
        window.location.href = data.data.game_url
      } else {
        showToast(2, "505 Error \n Format Invalid!")
      }
    } catch (error) {
      showToast(2, "505 \n Invalid Response!")
    }
  }

  const showNotice = (data) => {
    if (!getSessionStorage("isAlertShown") >= 1 && data.length > 0) {
      setNoticeDialogConst((previousState) => {
        return { ...previousState, noticeTitle: data[0] }
      })

      setNoticeDialogConst((previousState) => {
        return { ...previousState, noticeNote: data[1] }
      })

      setNoticeDialogConst((previousState) => {
        return { ...previousState, noticeDialogShow: true }
      })

      setSessionStorage("isAlertShown", 1)
    }
  }

  const updateNoticeDialogState = (data) => {
    setNoticeDialogConst((previousState) => {
      return { ...previousState, noticeDialogShow: data }
    })
  }

  function getAccountInfo(accountId, accountAuthSecret) {
    const fecthApiData = async (url, authSecret) => {
      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Route: "route-account-info",
            AuthToken: authSecret,
          },
        })
        const data = await res.json()

        setLoadingShow(false)

        if (data.status_code == "success") {
          const accountAvatarId = data.data[0]["account_avatar_id"]
          const accountUserName = data.data[0]["account_user_name"]
          const accountBalance = data.data[0]["account_balance"]
          const accountWinningBalance = data.data[0]["account_w_balance"]
          const accountCommissionBalance = data.data[0]["account_c_balance"]
          const accountLevel = data.data[0]["account_level"]
          const accountLastActive = data.data[0]["account_last_active"]

          const service_app_status = data.data[0]["service_app_status"]
          const service_min_recharge = data.data[0]["service_min_recharge"]
          const service_recharge_option = data.data[0]["service_recharge_option"]
          const service_telegram_url = data.data[0]["service_telegram_url"]
          const service_payment_url = data.data[0]["service_payment_url"]
          const service_livechat_url = data.data[0]["service_livechat_url"]
          const service_imp_message = data.data[0]["service_imp_message"]
          const service_app_download_url = data.data[0]["service_app_download_url"]

          setStorage("avatarId", accountAvatarId)
          setStorage("uname", accountUserName)
          setStorage("balance", accountBalance)
          setStorage("cbalance", accountCommissionBalance)
          setStorage("wbalance", accountWinningBalance)
          setStorage("wbalance", accountWinningBalance)
          setStorage("accountLevel", accountLevel)
          setStorage("accountLastActive", accountLastActive)
          setStorage("minrecharge", service_min_recharge)
          setStorage("rechargeoptions", service_recharge_option)
          setStorage("telegramURL", service_telegram_url)
          setStorage("liveChatURL", service_livechat_url)
          setStorage("paymentURL", service_payment_url)
          setStorage("impMessage", service_imp_message)
          setStorage("appDownloadURL", service_app_download_url)
          // setStorage("winnersArr", JSON.stringify(data.winnersArr))
          setConstants({
            ...pageConst,
            accountBalance: accountBalance,
            isDataLoaded: true,
          })

          if (service_app_status == "false") {
            navigate("/um", { replace: true })
          } else {
            updateWinnersList(data.winnersArr)
            showNotice(data.noticeArr)
            updateSliderImagesArr(data.slideShowList)
          }
        } else if (data.status_code == "authorization_error") {
          if (deleteStorage()) {
            navigate("/login", { replace: true })
          }
        }
      } catch (error) {
        setLoadingShow(false)
      }
    }

    if (!isLoadingShow && !pageConst.isDataLoaded) {
      setLoadingShow(true)
      fecthApiData(API_ACCESS_URL + "?USER_ID=" + accountId, accountAuthSecret)
    }
  }

  const getRandomNum = (min, max, type) => {
    if (type == "multi") {
      return Math.round((Math.random() * (max - min) + min) / 10) * 10
    } else {
      return Math.floor(Math.random() * (max - min) + min)
    }
  }

  const getRandBool = () => {
    let returnVal = false

    const status = Math.round(Math.random())
    if (status == 1) {
      returnVal = true
    }

    return returnVal
  }

  const updateWinnersList = (data) => {
    const tempData = []

    tempData.push(
      <div key={61}>
        <div className={[styles.winnersListStageView]}>
          <div className="col-view v-center mg-t--45">
            <div className="ps-rl">
              <img
                src={AVATARS_ARR[Number(data[1]["avatar_id"])]["avatarURL"] || "/placeholder.svg"}
                className="h-w-60 br-50"
                alt="icon"
              />
              <img
                src={require("../media/icons/crown_no2_icon.png") || "/placeholder.svg"}
                className="ps-ab ps-tp ps-lf--5 h-w-36 mg-t--20"
                alt="icon"
              />
            </div>

            <img
              src={require("../media/icons/win_no2_icon.png") || "/placeholder.svg"}
              className="h-18-p z-i-1 mg-t--10"
              alt="icon"
            />
            <p className="ft-sz-14 cl-white mg-t-15">{data[1]["mobile_num"]}</p>
            <div className="ft-sz-12 pd-5-10 mg-t-5 cl-white br-15 bg-l-white-2">Rs{data[1]["winning_amount"]}</div>
          </div>

          <div className="col-view v-center mg-t--90">
            <div className="ps-rl">
              <img
                src={AVATARS_ARR[Number(data[0]["avatar_id"])]["avatarURL"] || "/placeholder.svg"}
                className="h-w-60 br-50"
                alt="icon"
              />
              <img
                src={require("../media/icons/crown_no1_icon.png") || "/placeholder.svg"}
                className="ps-ab ps-tp ps-lf--5 h-w-36 mg-t--20"
                alt="icon"
              />
            </div>

            <img
              src={require("../media/icons/win_no1_icon.png") || "/placeholder.svg"}
              className="h-18-p z-i-1 mg-t--10"
              alt="icon"
            />
            <p className="ft-sz-14 cl-white mg-t-15">{data[0]["mobile_num"]}</p>
            <div className="ft-sz-12 pd-5-10 mg-t-5 cl-white br-15 bg-l-white-2">Rs{data[0]["winning_amount"]}</div>
          </div>

          <div className="col-view v-center mg-t--45">
            <div className="ps-rl">
              <img
                src={AVATARS_ARR[Number(data[2]["avatar_id"])]["avatarURL"] || "/placeholder.svg"}
                className="h-w-60 br-50"
                alt="icon"
              />
              <img
                src={require("../media/icons/crown_no3_icon.png") || "/placeholder.svg"}
                className="ps-ab ps-tp ps-lf--5 h-w-36 mg-t--20"
                alt="icon"
              />
            </div>

            <img
              src={require("../media/icons/win_no3_icon.png") || "/placeholder.svg"}
              className="h-18-p z-i-1 mg-t--10"
              alt="icon"
            />
            <p className="ft-sz-14 cl-white mg-t-15">{data[2]["mobile_num"]}</p>
            <div className="ft-sz-12 pd-5-10 mg-t-5 cl-white br-15 bg-l-white-2">Rs{data[2]["winning_amount"]}</div>
          </div>
        </div>
      </div>,
    )

    for (let i = 3; i < data.length; i++) {
      tempData.push(
        <div
          key={i}
          className={[
            general.rowView,
            general.spaceBetween,
            styles.winnerPersonView,
            i > 3 ? general.mgT10px : "",
          ].join(" ")}
        >
          <div className="row-view">
            <span className={[general.fontS20Px, general.width20px].join(" ")}>{i + 1}</span>

            <div className="h-w-45 ovf-hidden br-50 mg-l-40">
              <img
                src={AVATARS_ARR[Number(data[i]["avatar_id"])]["avatarURL"] || "/placeholder.svg"}
                className="h-w-45"
                alt="icon"
              />
            </div>
            <span className={[general.fontS16Px, general.mgL10px].join(" ")}>{data[i]["mobile_num"]}</span>
          </div>
          <span className={[styles.winnerWonAmountView]}>Rs{data[i]["winning_amount"]}</span>
        </div>,
      )
    }

    setConstants((previousState) => {
      return { ...previousState, winnersRecordList: tempData }
    })
  }

  // Replace the openGame function with this updated version that checks balance:

  const openGame = (url) => {
    if (getStorage("uid")) {
      // Check if balance is sufficient (at least 100 Rs)
      const balance = Number.parseFloat(getStorage("balance") || "0")
      if (balance < 0) {
        updateToastDialogState(true, 2, "You need at least 100 Rs balance to play this game")

        // Auto-hide toast after 3 seconds
        setTimeout(() => {
          updateToastDialogState(false, 2, "")
        }, 3000)
        return
      }
      navigate("/" + url, { replace: false })
    } else {
      redirectToLogin()
    }
  }

  const redirectToLogin = () => {
    deleteStorage()
    navigate("/login", { replace: true })
  }

  // Add this function after updateToastDialogState
  const showToast = (mode, message) => {
    updateToastDialogState(true, mode, message)

    // Auto-hide toast after 3 seconds
    setTimeout(() => {
      updateToastDialogState(false, mode, "")
    }, 3000)
  }

  useEffect(() => {
    let accountId = ""
    let accountAuthSecret = ""

    if (getStorage("uid")) {
      accountId = getStorage("uid")
      accountAuthSecret = getStorage("secret")
    } else {
      accountId = "guest"
      accountAuthSecret = "guest"
    }

    getAccountInfo(accountId, accountAuthSecret)
  }, [pageConst.sliderImages, pageConst.winnersList])

  const cancelGameLoading = () => {
    setIsGameLoading(false)
    setLoadingGameName("")
    // showToast(2, "Game loading cancelled")
  }

  return (
    <div className={[general.viewCenter, general.appBackground].join(" ")}>
      <div
        className={[
          general.height100vh,
          general.respWidth,
          general.overflowScrollY,
          general.appContentsBackground,
          general.hideScrollBar,
        ].join(" ")}
      >
        <NoticeDialog intentData={noticeDialogConst} updateState={updateNoticeDialogState} />

        {/* Toast Notification */}
        {toastDialogConst.toastDialogShow && (
          <div
            style={{
              position: "fixed",
              top: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: toastDialogConst.toastDialogMode === 1 ? "#4CAF50" : "#f44336",
              color: "white",
              padding: "15px 20px",
              borderRadius: "8px",
              zIndex: 3000,
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              maxWidth: "80%",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            {toastDialogConst.toastMessage}
          </div>
        )}

        {/* Custom Confirmation Dialog */}
        {confirmDialog.isOpen && (
          <div style={customPopupStyles.overlay}>
            <div style={customPopupStyles.modal}>
              <div style={customPopupStyles.header}>
                <div style={customPopupStyles.title}>Open Game</div>
                <div style={customPopupStyles.description}>Are you sure you want to open {confirmDialog.gameName}?</div>
              </div>
              <div style={customPopupStyles.buttonContainer}>
                <button style={customPopupStyles.cancelButton} onClick={closeConfirmDialog}>
                  Cancel
                </button>
                <button style={customPopupStyles.confirmButton} onClick={proceedWithGameOpen}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Loading Overlay */}
        {isGameLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              zIndex: 2000,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="spinner"
              style={{
                width: "60px",
                height: "60px",
                border: "5px solid rgba(255, 255, 255, 0.3)",
                borderRadius: "50%",
                borderTop: "5px solid #f2ca33",
                animation: "spin 1s linear infinite",
                marginBottom: "15px",
              }}
            ></div>
            <p style={{ color: "white", fontSize: "18px", fontWeight: "500", marginBottom: "20px" }}>
              Opening {loadingGameName}...
            </p>
            <button
              onClick={cancelGameLoading}
              style={{
                padding: "8px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              }}
            >
              Cancel
            </button>
            <style jsx>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        )}

        <div className={[styles.homeView, general.posRelative].join(" ")}>
          <div
            className={[
              styles.topBar,
              general.rowView,
              general.spaceBetween,
              general.width100,
              general.bgCustomColor4,
            ].join(" ")}
          >
            <img
              className={`h-40-p mg-l-10`}
              src={require("../media/icons/app_logo.png") || "/placeholder.svg"}
              alt="icon"
            />

            <div className={[!getStorage("uid") ? general.hideView : ""]}>
              <img
                className={`h-25-p`}
                src={require("../media/icons/customer_service_icon.png") || "/placeholder.svg"}
                alt="icon"
                onClick={() => window.open("https://t.me/Leo99spots", "_blank")}
              />

              <img
                className={`h-25-p mg-l-15`}
                src={require("../media/icons/download_icon.png") || "/placeholder.svg"}
                alt="icon"
                onClick={() => openNewPage(getStorage("appDownloadURL"))}
              />
            </div>

            <div className={[general.rowView, !getStorage("uid") ? "" : general.hideView].join(" ")}>
              <Link
                className={[
                  general.textDecoNone,
                  general.height30px,
                  general.viewCenter,
                  general.colorWhite,
                  general.fontS14Px,
                  general.pd5px15px,
                  general.borderRadius,
                  general.bgCustomColor3,
                ].join(" ")}
                to={"/login"}
              >
                Login
              </Link>

              <Link
                className={[
                  general.textDecoNone,
                  general.height30px,
                  general.viewCenter,
                  general.colorWhite,
                  general.fontS14Px,
                  general.pd5px15px,
                  general.mgL10px,
                  general.borderRadius,
                  general.bgCustomColor2,
                ].join(" ")}
                to={"/register"}
              >
                Register
              </Link>
            </div>
          </div>

          <SlideShow dataList={pageConst.sliderImages} />

          <div className="pd-0-15">
            <ImportantNotice />
          </div>

          <div className={[styles.homeGameOptionsView]}>
            <div className={[styles.gameOptionsView2]}>
              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory4].join(" ")}
                onClick={() => setViewBoxNumber(1)}
              >
                <img src={require("../media/icons/backgrounds/11.png") || "/placeholder.svg"} alt="icon" />
                <span>Slots</span>
              </div>

              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory3].join(" ")}
                onClick={() => setViewBoxNumber(2)}
              >
                <img src={require("../media/icons/backgrounds/7.png") || "/placeholder.svg"} alt="icon" />
                <span>Sports</span>
              </div>

              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory1, styles.bgCategoryActive].join(" ")}
                onClick={() => setViewBoxNumber(3)}
              >
                <img src={require("../media/icons/backgrounds/12.png") || "/placeholder.svg"} alt="icon" />
                <span>Live Casion</span>
              </div>

             

            </div>
          </div>

          <div className={[styles.homeGameOptionsView]}>
            <div className={[styles.gameOptionsView2]}>
              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory4].join(" ")}
                onClick={() => setViewBoxNumber(7)}
              >
                <img src={require("../media/icons/backgrounds/9.png") || "/placeholder.svg"} alt="icon" />
                <span>Fishing</span>
              </div>

              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory3].join(" ")}
                onClick={() => setViewBoxNumber(11)}
              >
                <img src={require("../media/icons/backgrounds/8.png") || "/placeholder.svg"} alt="icon" />
                <span>Poker</span>
              </div>

              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory1, styles.bgCategoryActive].join(" ")}
                onClick={() => setViewBoxNumber(12)}
              >
                <img src={require("../media/icons/backgrounds/10.png") || "/placeholder.svg"} alt="icon" />
                <span>Table game</span>
              </div>

             

            </div>
          </div>

          <div className={[styles.homeGameOptionsView]}>
            <div className={[styles.gameOptionsView1]}>
              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory1].join(" ")}
                onClick={() => setViewBoxNumber(8)}
              >
                <img src={require("../media/icons/backgrounds/111.png") || "/placeholder.svg"} alt="icon" />
                <span>Mini Games</span>
              </div>

              <div
                className={[styles.colView, styles.alignCenter, styles.bgCategory2].join(" ")}
                onClick={() => setViewBoxNumber(0)}
              >
                <img src={require("../media/icons/backgrounds/15.png") || "/placeholder.svg"} alt="icon" />
                <span>Lottery</span>
              </div>
            </div>
          </div>
          <div className={[styles.homeAdditionalGamesTitle, viewBoxNumber != 0 ? styles.hideView : ""].join(" ")}>
            <span></span>
            Lottery
          </div>

          {/* all games */}
          <div className={[styles.colView, styles.pd15px, viewBoxNumber != 0 ? styles.hideView : ""].join(" ")}>
            <div className="ps-rl txt-deco-n br-10 bg-white" onClick={() => openGame("wingo", "Win Go")}>
              <div className={[styles.homeGameViewBox]}></div>
              <img
                className="h-85-p ps-ab ps-rgt-10 ps-tp--15px"
                src={require("../Games/Wingo/icons/4.png") || "/placeholder.svg"}
              />
              <div className="col-view ps-ab ps-lf ps-tp pd-15">
                <span className="ft-sz-23 ft-wgt-500 cl-white">Win Go</span>
                <span className="ft-sz-12 cl-white mg-t-10">Guess Number</span>
                <span className="ft-sz-12 cl-white">Green/Red/Purple to win</span>
              </div>

              <div className="row-view sb-view pd-10-15 br-10 bg-white">
                <div className="row-view">
                  <div className="h-w-32 ovf-hidden br-50">
                    <img
                      src={AVATARS_ARR[getRandomInt(0, 7)]["avatarURL"] || "/placeholder.svg"}
                      className="h-w-32"
                      alt="icon"
                    />
                  </div>

                  <span className="ft-sz-13 cl-drk-black mg-l-10">*****{getRandomInt(100, 999)}</span>
                </div>

                <span className="ft-sz-13 cl-drk-black mg-l-10">Won Amount: Rs{getRandomInt(2, 1600).toFixed(2)}</span>
              </div>
            </div>

            <div
              className="ps-rl txt-deco-n br-10 mg-t-30 bg-white"
              onClick={() => openGame("k3lottery1min", "K3 Lottery")}
            >
              <div className={[styles.homeGameViewBox]}></div>
              <img
                className="h-85-p ps-ab ps-rgt-10 ps-tp--15px"
                src={require("../icons/dice_lottery_icon.png") || "/placeholder.svg"}
              />
              <div className="col-view ps-ab ps-lf ps-tp pd-15">
                <span className="ft-sz-23 ft-wgt-500 cl-white">K3 Lottery</span>
                <span className="ft-sz-12 cl-white mg-t-10">Guess Number</span>
                <span className="ft-sz-12 cl-white">Big/Small/Odd/Even</span>
              </div>

              <div className="row-view sb-view pd-10-15 br-10 bg-white">
                <div className="row-view">
                  <div className="h-w-32 ovf-hidden br-50">
                    <img
                      src={AVATARS_ARR[getRandomInt(0, 7)]["avatarURL"] || "/placeholder.svg"}
                      className="h-w-32"
                      alt="icon"
                    />
                  </div>

                  <span className="ft-sz-13 cl-drk-black mg-l-10">*****{getRandomInt(100, 999)}</span>
                </div>

                <span className="ft-sz-13 cl-drk-black mg-l-10">Won Amount: Rs{getRandomInt(2, 1600).toFixed(2)}</span>
              </div>
            </div>

            <div
              className="ps-rl txt-deco-n br-10 mg-t-30 bg-white"
              onClick={() => openGame("AndarBahar", "Andar Bahar")}
            >
              <div className={[styles.homeGameViewBox]}></div>
              <img
                className="h-85-p ps-ab ps-rgt-10 ps-tp--15px"
                src={require("../icons/5dlottery_icon.png") || "/placeholder.svg"}
              />
              <div className="col-view ps-ab ps-lf ps-tp pd-15">
                <span className="ft-sz-23 ft-wgt-500 cl-white">Andar Bahar</span>
                <span className="ft-sz-12 cl-white mg-t-10">Guess Number</span>
                <span className="ft-sz-12 cl-white">Green/Red/Purple to win</span>
              </div>

              <div className="row-view sb-view pd-10-15 br-10 bg-white">
                <div className="row-view">
                  <div className="h-w-32 ovf-hidden br-50">
                    <img
                      src={AVATARS_ARR[getRandomInt(0, 7)]["avatarURL"] || "/placeholder.svg"}
                      className="h-w-32"
                      alt="icon"
                    />
                  </div>

                  <span className="ft-sz-13 cl-drk-black mg-l-10">*****{getRandomInt(100, 999)}</span>
                </div>

                <span className="ft-sz-13 cl-drk-black mg-l-10">Won Amount: Rs{getRandomInt(2, 1600).toFixed(2)}</span>
              </div>
            </div>

            <div
              className="ps-rl txt-deco-n br-10 mg-t-30 bg-white"
              onClick={() => openGame("Wheelocity", "Wheelocity")}
            >
              <div className={[styles.homeGameViewBox]}></div>
              <img
                className="h-85-p ps-ab ps-rgt-10 ps-tp--15px"
                src={require("../media/icons/backgrounds/wheelocity_bg.png") || "/placeholder.svg"}
              />
              <div className="col-view ps-ab ps-lf ps-tp pd-15">
                <span className="ft-sz-23 ft-wgt-500 cl-white">Wheelocity</span>
                <span className="ft-sz-12 cl-white mg-t-10">Guess Animal Number</span>
                <span className="ft-sz-12 cl-white">Elephant/Tiger/Crown to win</span>
              </div>

              <div className="row-view sb-view pd-10-15 br-10 bg-white">
                <div className="row-view">
                  <div className="h-w-32 ovf-hidden br-50">
                    <img
                      src={AVATARS_ARR[getRandomInt(0, 7)]["avatarURL"] || "/placeholder.svg"}
                      className="h-w-32"
                      alt="icon"
                    />
                  </div>

                  <span className="ft-sz-13 cl-drk-black mg-l-10">*****{getRandomInt(100, 999)}</span>
                </div>

                <span className="ft-sz-13 cl-drk-black mg-l-10">Won Amount: Rs{getRandomInt(2, 1600).toFixed(2)}</span>
              </div>
            </div>
          </div>
          <div className={[styles.homeAdditionalGamesTitle, viewBoxNumber != 1 ? styles.hideView : ""].join(" ")}>
            <span></span>
            <div className={[styles.headinggames]}>
              Slots
              <div className={[styles.seeallbutton]}>
                {/* <div className={[styles.seealltext]}>See all     
            </div> 
            <svg height="1em" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 2"><path d="M16.88 15.53 7 5.66a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path><path d="m26.46 15.53-9.88-9.87a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path></g></svg> */}
              </div>
            </div>
          </div>

          <div className={[styles.homeAdditionalGamesView, viewBoxNumber != 1 ? styles.hideView : ""].join(" ")}>
          <div>
              <img
                src="https://mediumrare.imgix.net/293b2337d4d5cfda999ca423e34518a1a6682062340f1f1c5a669a26e7927c79?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("fd4d50fd42d7453c20776398269ee6c5", "Le Pharaoh")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Chin-Shi-Huang.png"
                alt="icon"
                onClick={() => confirmGameOpen("24da72b49b0dd0e5cbef9579d09d8981", "Chin Shi Huang")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/God-Of-Martial.png"
                alt="icon"
                onClick={() => confirmGameOpen("21ef8a7ddd39836979170a2e7584e333", "God Of Martial")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hot-Chilli.png	"
                alt="icon"
                onClick={() => confirmGameOpen("6a7e156ceec5c581cd6b9251854fe504", "Fortune Tree")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/War-Of-Dragons.png"
                alt="icon"
                onClick={() => confirmGameOpen("4b1d7ffaf9f66e6152ea93a6d0e4215b", "War Of Dragons")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Gem-Party.png"
                alt="icon"
                onClick={() => confirmGameOpen("756cf3c73a323b4bfec8d14864e3fada", "Gem Party")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Ball.png"
                alt="icon"
                onClick={() => confirmGameOpen("893669898cd25d9da589a384f1d004df", "Lucky Ball")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hyper-Burst.png"
                alt="icon"
                onClick={() => confirmGameOpen("a47b17970036b37c1347484cf6956920", "Hyper Burst")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Shanghai-Beauty.png"
                alt="icon"
                onClick={() => confirmGameOpen("795d0cae623cbf34d7f1aa93bbcded28", "Shanghai Beauty")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fa-Fa-Fa.png"
                alt="icon"
                onClick={() => confirmGameOpen("54c41adcf43fdb6d385e38bc09cd77ca", "Fa Fa Fa")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Candy-Baby.png"
                alt="icon"
                onClick={() => confirmGameOpen("2cc3b68cbcfacac2f7ef2fe19abc3c22", "Candy Baby")}
              />
            </div>
            <div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Agent-Ace.png"
        alt="Agent Ace"
        onClick={() => confirmGameOpen("8a4b4929e796fda657a2d38264346509", "Agent Ace")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ali-Baba.png"
        alt="Ali Baba"
        onClick={() => confirmGameOpen("cc686634b4f953754b306317799f1f39", "Ali Baba")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Aztec-Priestess.png"
        alt="Aztec Priestess"
        onClick={() => confirmGameOpen("6acff19b2d911a8c695ba24371964807", "Aztec Priestess")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bangla-Beauty.png"
        alt="Bangla Beauty"
        onClick={() => confirmGameOpen("6b60d159f0939a45f7b4c88a9b57499a", "Bangla Beauty")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bao-boon-chin.png"
        alt="Bao boon chin"
        onClick={() => confirmGameOpen("8c4ebb3dc5dcf7b7fe6a26d5aadd2c3d", "Bao boon chin")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bonus-Hunter.png"
        alt="Bonus Hunter"
        onClick={() => confirmGameOpen("39775cdc4170e56c5f768bdee8b4fa00", "Bonus Hunter")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Book-of-Gold.png"
        alt="Book of Gold"
        onClick={() => confirmGameOpen("6b283c434fd44250d83b7c2420f164f9", "Book of Gold")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bone-Fortune.png"
        alt="Bone Fortune"
        onClick={() => confirmGameOpen("aab3048abc6a88e0759679fbe26e6a8d", "Bone Fortune")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Boxing-King.png"
        alt="Boxing King"
        onClick={() => confirmGameOpen("981f5f9675002fbeaaf24c4128b938d7", "Boxing King")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bubble-Beauty.png"
        alt="Bubble Beauty"
        onClick={() => confirmGameOpen("a78d2ed972aab8ba06181cc43c54a425", "Bubble Beauty")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Charge-Buffalo-Ascent.png"
        alt="Charge Buffalo Ascent"
        onClick={() => confirmGameOpen("28bc4a33c985ddce6acd92422626b76f", "Charge Buffalo Ascent")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Charge-Buffalo.png"
        alt="Charge Buffalo"
        onClick={() => confirmGameOpen("984615c9385c42b3dad0db4a9ef89070", "Charge Buffalo")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-FaFaFa.png"
        alt="Crazy FaFaFa"
        onClick={() => confirmGameOpen("a57a8d5176b54d4c825bd1eee8ab34df", "Crazy FaFaFa")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Hunter.png"
        alt="Crazy Hunter"
        onClick={() => confirmGameOpen("69082f28fcd46cbfd10ce7a0051f24b6", "Crazy Hunter")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Pusher.png"
        alt="Crazy Pusher"
        onClick={() => confirmGameOpen("00d92d5cec10cf85623938222a6c2bb6", "Crazy Pusher")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bone-Fortune.png"
        alt="Bone Fortune"
        onClick={() => confirmGameOpen("aab3048abc6a88e0759679fbe26e6a8d", "Bone Fortune")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/JILI-CAISHEN.png"
        alt="JILI CAISHEN"
        onClick={() => confirmGameOpen("11e330c2b23f106815f3b726d04e4316", "JILI CAISHEN")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bonus-Hunter.png"
        alt="Bonus Hunter"
        onClick={() => confirmGameOpen("39775cdc4170e56c5f768bdee8b4fa00", "Bonus Hunter")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Witchs-Love.png"
        alt="Witch's Love Icon"
        onClick={() => confirmGameOpen("730934d13092e3f9e7c23f2a774e663a", "Witch's Love")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Neko-Maid.png"
        alt="Neko Maid Icon"
        onClick={() => confirmGameOpen("177977776019fe295e1fa61383400b92", "Neko Maid")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Adventure-Of-Sinbad.png"
        alt="Adventure Of Sinbad Icon"
        onClick={() => confirmGameOpen("4349ce1ba0fc4c1c794a11d18d7ba94b", "Adventure Of Sinbad")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/G-idol.png"
        alt="G-idol Icon"
        onClick={() => confirmGameOpen("c86ff6fdb3e91db1b7d110d58a778a74", "G-idol")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Goal-Line-Baby.png"
        alt="Goal Line Baby Icon"
        onClick={() => confirmGameOpen("364805284c56dc5888fd21e73be3dda2", "Goal Line Baby")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Miss-Holmes-Cold-Case.png"
        alt="Miss Holmes: Cold Case Icon"
        onClick={() => confirmGameOpen("045efa0ecf10c2d171f93db6c1e2e75c", "Miss Holmes: Cold Case")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Kitsune-Sister.png"
        alt="Kitsune Sister Icon"
        onClick={() => confirmGameOpen("70c6ce3e01e79c019a9bd68522826993", "Kitsune Sister")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Queen-Of-Casino.png"
        alt="Queen Of Casino Icon"
        onClick={() => confirmGameOpen("b84161166710f1ab3223421c92b406cb", "Queen Of Casino")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Streaming-Girl.png"
        alt="Streaming Girl Icon"
        onClick={() => confirmGameOpen("bf89fbb9dbef22224b3da74f6654e1a5", "Streaming Girl")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Dim-Sum-Hottie.png"
        alt="Dim Sum Hottie Icon"
        onClick={() => confirmGameOpen("920fe25ea07729a287c668216bdfc256", "Dim Sum Hottie")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Goddess-Wonderland.png"
        alt="Goddess Wonderland Icon"
        onClick={() => confirmGameOpen("9d18644a1c6951932f0b7ced77ff0f49", "Goddess Wonderland")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Napoleon.png"
        alt="Napoleon Icon"
        onClick={() => confirmGameOpen("422b086bd63d28be3e812dbb7736b9b8", "Napoleon")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Tron-Century.png"
        alt="Tron: Century Icon"
        onClick={() => confirmGameOpen("35c52efe2c5618e5bc3bdf47d5da1dd2", "Tron: Century")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Glory-of-Poseidon.png"
        alt="Glory of Poseidon Icon"
        onClick={() => confirmGameOpen("357e66a063eb207b7d5d9b841b313801", "Glory of Poseidon")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Beauty-SPA.png"
        alt="Beauty SPA Icon"
        onClick={() => confirmGameOpen("4f000007fa6a15bfe51d1ce1766e57b7", "Beauty SPA")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/eg46/Bikini-Revelry.png"
        alt="Bikini Revelry Icon"
        onClick={() => confirmGameOpen("66c29ee5ba8641cd859a8f139142402e", "Bikini Revelry")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/World-Cup.png"
        alt="World Cup"
        onClick={() => confirmGameOpen("28374b7ad7c91838a46404f1df046e5a", "World Cup")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Samba.png"
        alt="Samba"
        onClick={() => confirmGameOpen("6d35789b2f419c1db3926350d57c58d8", "Samba")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Neko-Fortune.png"
        alt="Neko Fortune"
        onClick={() => confirmGameOpen("9a391758f755cb30ff973e08b2df6089", "Neko Fortune")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Racer.png"
        alt="Wild Racer"
        onClick={() => confirmGameOpen("2f0c5f96cda3c6e16b3929dd6103df8e", "Wild Racer")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pirate-Queen.png"
        alt="Pirate Queen"
        onClick={() => confirmGameOpen("70999d5bcf2a1d1f1fb8c82e357317f4", "Pirate Queen")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Joker.png"
        alt="Golden Joker"
        onClick={() => confirmGameOpen("f301fe0b22d1540b1f215d282b20c642", "Golden Joker")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Ace.png"
        alt="Wild Ace"
        onClick={() => confirmGameOpen("9a3b65e2ae5343df349356d548f3fc4b", "Wild Ace")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Master-Tiger.png"
        alt="Master Tiger"
        onClick={() => confirmGameOpen("d2b48fe98ac2956eeefd2bc4f7e0335a", "Master Tiger")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Gems-2.png"
        alt="Fortune Gems 2"
        onClick={() => confirmGameOpen("664fba4da609ee82b78820b1f570f4ad", "Fortune Gems 2")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sweet-Land.png"
        alt="Sweet Land"
        onClick={() => confirmGameOpen("91250a55f75a3c67ed134b99bf587225", "Sweet Land")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Cricket-King-18.png"
        alt="Cricket King 18"
        onClick={() => confirmGameOpen("dcf220f4e3ecca0278911a55e6f11c77", "Cricket King 18")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Elf-Bingo.png"
        alt="Elf Bingo"
        onClick={() => confirmGameOpen("5cec2b309a8845b38f8e9b4e6d649ea2", "Elf Bingo")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Cricket-Sah-75.png"
        alt="Cricket Sah 75"
        onClick={() => confirmGameOpen("6720a0ce1d06648ff390fbea832798a9", "Cricket Sah 75")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Temple.png"
        alt="Golden Temple"
        onClick={() => confirmGameOpen("976c5497256c020ac012005f6bb166ad", "Golden Temple")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Devil-Fire.png"
        alt="Devil Fire"
        onClick={() => confirmGameOpen("1b4c5865131b4967513c1ee90cba4472", "Devil Fire")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bangla-Beauty.png"
        alt="Bangla Beauty"
        onClick={() => confirmGameOpen("6b60d159f0939a45f7b4c88a9b57499a", "Bangla Beauty")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Aztec-Priestess.png"
        alt="Aztec Priestess"
        onClick={() => confirmGameOpen("6acff19b2d911a8c695ba24371964807", "Aztec Priestess")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Monkey.png"
        alt="Fortune Monkey"
        onClick={() => confirmGameOpen("add95fc40f1ef0d56f5716ce45a56946", "Fortune Monkey")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dabanggg.png"
        alt="Dabanggg"
        onClick={() => confirmGameOpen("5404a45b06826911c3537fdf935c281f", "Dabanggg")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sin-City.png"
        alt="Sin City"
        onClick={() => confirmGameOpen("830cac2f5da6cc1fb91cfae04b85b1e2", "Sin City")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/King-Arthur.png"
        alt="King Arthur"
        onClick={() => confirmGameOpen("fafab1a17a237d0fc0e50c20d2c2bf4c", "King Arthur")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Charge-Buffalo-Ascent.png"
        alt="Charge Buffalo Ascent"
        onClick={() => confirmGameOpen("28bc4a33c985ddce6acd92422626b76f", "Charge Buffalo Ascent")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Witches-Night.png"
        alt="Witches Night"
        onClick={() => confirmGameOpen("82c5c404cf4c0790deb42a2b5653533c", "Witches Night")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Money-Coming.png"
        alt="Money Coming"
        onClick={() => confirmGameOpen("db249defce63610fccabfa829a405232", "Money Coming")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Queen.png"
        alt="Golden Queen"
        onClick={() => confirmGameOpen("8de99455c2f23f6827666fd798eb80ef", "Golden Queen")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jungle-King.png"
        alt="Jungle King"
        onClick={() => confirmGameOpen("4db0ec24ff55a685573c888efed47d7f", "Jungle King")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Monkey-Party.png"
        alt="Monkey Party"
        onClick={() => confirmGameOpen("fd369a4a7486ff303beea267ec5c8eff", "Monkey Party")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Boxing-King.png"
        alt="Boxing King"
        onClick={() => confirmGameOpen("981f5f9675002fbeaaf24c4128b938d7", "Boxing King")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Secret-Treasure.png"
        alt="Secret Treasure"
        onClick={() => confirmGameOpen("1d1f267e3a078ade8e5ccd56582ac94f", "Secret Treasure")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pharaoh-Treasure.png"
        alt="Pharaoh Treasure"
        onClick={() => confirmGameOpen("c7a69ab382bd1ff0e6eb65b90a793bdd", "Pharaoh Treasure")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Coming.png"
        alt="Lucky Coming"
        onClick={() => confirmGameOpen("ba858ec8e3b5e2b4da0d16b3a2330ca7", "Lucky Coming")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Rich.png"
        alt="Super Rich"
        onClick={() => confirmGameOpen("b92f491a63ac84b106b056e9d46d35c5", "Super Rich")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/RomaX.png"
        alt="Roma X"
        onClick={() => confirmGameOpen("e5ff8e72418fcc608d72ea21cc65fb70", "Roma X")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Empire.png"
        alt="Golden Empire"
        onClick={() => confirmGameOpen("490096198e28f770a3f85adb6ee49e0f", "Golden Empire")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Gems.png"
        alt="Fortune Gems"
        onClick={() => confirmGameOpen("a990de177577a2e6a889aaac5f57b429", "Fortune Gems")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Hunter.png"
        alt="Crazy Hunter"
        onClick={() => confirmGameOpen("69082f28fcd46cbfd10ce7a0051f24b6", "Crazy Hunter")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Party-Night.png"
        alt="Party Night"
        onClick={() => confirmGameOpen("d505541d522aa5ca01fc5e97cfcf2116", "Party Night")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Magic-Lamp.png"
        alt="Magic Lamp"
        onClick={() => confirmGameOpen("582a58791928760c28ec4cef3392a49f", "Magic Lamp")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Agent-Ace.png"
        alt="Agent Ace"
        onClick={() => confirmGameOpen("8a4b4929e796fda657a2d38264346509", "Agent Ace")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TWIN-WINS.png"
        alt="TWIN WINS"
        onClick={() => confirmGameOpen("c74b3cbda5d16f77523e41c25104e602", "TWIN WINS")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ali-Baba.png"
        alt="Ali Baba"
        onClick={() => confirmGameOpen("cc686634b4f953754b306317799f1f39", "Ali Baba")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mega-Ace.png"
        alt="Mega Ace"
        onClick={() => confirmGameOpen("eba92b1d3abd5f0d37dfbe112abdf0e2", "Mega Ace")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Medusa.png"
        alt="Medusa"
        onClick={() => confirmGameOpen("2c17b7c4e2ce5b8bebf4bd10e3e958d7", "Medusa")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Book-of-Gold.png"
        alt="Book of Gold"
        onClick={() => confirmGameOpen("6b283c434fd44250d83b7c2420f164f9", "Book of Gold")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Thor-X.png"
        alt="Thor X"
        onClick={() => confirmGameOpen("7e6aa773fa802aaa9cb1f2fac464736e", "Thor X")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Happy-Taxi.png"
        alt="Happy Taxi"
        onClick={() => confirmGameOpen("1ed896aae4bdc78c984021307b1dd177", "Happy Taxi")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Gold-Rush.png"
        alt="Gold Rush"
        onClick={() => confirmGameOpen("2a5d731e0fd60f52873a24ece11f2c0b", "Gold Rush")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mayan-Empire.png"
        alt="Mayan Empire"
        onClick={() => confirmGameOpen("5c2383ef253f9c36dacec4b463d61622", "Mayan Empire")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Pusher.png"
        alt="Crazy Pusher"
        onClick={() => confirmGameOpen("00d92d5cec10cf85623938222a6c2bb6", "Crazy Pusher")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bone-Fortune.png"
        alt="Bone Fortune"
        onClick={() => confirmGameOpen("aab3048abc6a88e0759679fbe26e6a8d", "Bone Fortune")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/JILI-CAISHEN.png"
        alt="JILI CAISHEN"
        onClick={() => confirmGameOpen("11e330c2b23f106815f3b726d04e4316", "JILI CAISHEN")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bonus-Hunter.png"
        alt="Bonus Hunter"
        onClick={() => confirmGameOpen("39775cdc4170e56c5f768bdee8b4fa00", "Bonus Hunter")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/World-Cup.png"
        alt="World Cup"
        onClick={() => confirmGameOpen("28374b7ad7c91838a46404f1df046e5a", "World Cup")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Samba.png"
        alt="Samba"
        onClick={() => confirmGameOpen("6d35789b2f419c1db3926350d57c58d8", "Samba")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Neko-Fortune.png"
        alt="Neko Fortune"
        onClick={() => confirmGameOpen("9a391758f755cb30ff973e08b2df6089", "Neko Fortune")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Racer.png"
        alt="Wild Racer"
        onClick={() => confirmGameOpen("2f0c5f96cda3c6e16b3929dd6103df8e", "Wild Racer")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pirate-Queen.png"
        alt="Pirate Queen"
        onClick={() => confirmGameOpen("70999d5bcf2a1d1f1fb8c82e357317f4", "Pirate Queen")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Joker.png"
        alt="Golden Joker"
        onClick={() => confirmGameOpen("f301fe0b22d1540b1f215d282b20c642", "Golden Joker")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Ace.png"
        alt="Wild Ace"
        onClick={() => confirmGameOpen("9a3b65e2ae5343df349356d548f3fc4b", "Wild Ace")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Master-Tiger.png"
        alt="Master Tiger"
        onClick={() => confirmGameOpen("d2b48fe98ac2956eeefd2bc4f7e0335a", "Master Tiger")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Gems-2.png"
        alt="Fortune Gems 2"
        onClick={() => confirmGameOpen("664fba4da609ee82b78820b1f570f4ad", "Fortune Gems 2")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sweet-Land.png"
        alt="Sweet Land"
        onClick={() => confirmGameOpen("91250a55f75a3c67ed134b99bf587225", "Sweet Land")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Cricket-King-18.png"
        alt="Cricket King 18"
        onClick={() => confirmGameOpen("dcf220f4e3ecca0278911a55e6f11c77", "Cricket King 18")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Elf-Bingo.png"
        alt="Elf Bingo"
        onClick={() => confirmGameOpen("5cec2b309a8845b38f8e9b4e6d649ea2", "Elf Bingo")}
    />
</div>

            <div>
              <img
                src="https://mediumrare.imgix.net/8f495d55e1cdbef9a5995b7133d6f4ad1b9a332493ade8b29a82f048ecda7388?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("e175cdd3215a02f5539cc8354a149b75", "Fortune Rabbit")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/7ac7169ca980177d2f7843face3046fb42c001bf4dd7356becb037e92fc07ff1?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("32776cbf601015f626a96ccecb1137d9", "Phoenix DuelReels")}
              />
            </div>
            <div>
              <img
                src="https://mediumrare.imgix.net/13e8f3e599761b56b46dd50d579de529b0173c35fd90127e841c2abdc04020da?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("c5435a8a73707a3a8bb4fe8baaaef3d2", "Fortune Dragon")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/30be38fdc2b4d9a6c76194314dfb7814a66d6905287ade354a0e5f2a79b1ab27?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() =>
                  confirmGameOpen("e175cdd3215a02f553752490080e5e310b5a3f823de33deed39cc8354a149b75", "SixSixSix")
                }
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/8ade942d35d2cdbddf7888f303be4cf4bda8c650a112b3c53f7c6f3ccad81254?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("2fbd2533b1bb03d5e03bfa80dd5da0bf", "Le Bandit")}
              />
            </div>
            <div>
              <img
                src="https://mediumrare.imgix.net/cafad5a2680956ba8bdc5f7ef147d23a8300f7debf44bb76510cd4ee97505aa4?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("8170339cc716c66d5b52779119fd718f", "Sugar Rush Xmas")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/857e57fe97696eb3cdbd5c226b87b4357ef8e2926c75571e7e7ee70b082155b2?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("0ab1d901b6cc731b48bc3b2cd07b3cf1", "Vampy Party")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/d0da486c2ef84196c52198fce55b4566303ef3d73d94c675179a8f6c4c5a3781?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("173c3e7cb587af08a8aa2026e490b832", "Donny Dough")}
              />
            </div>
            <div>
              <img
                src="https://mediumrare.imgix.net/b18560b8631fc3b27c06d41e9729f7774048864ad7c4a16d1a20b1a953883943?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("a1686de737ae9cd841d500c825720778", "Magic Piggy")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/7dbec5678181612dc2ea2257b42e7244836a24f7758cb48786bd59dd6cde0d8b?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("95fc290bb05c07b5aad1a054eba4dcc4", "Wild Bandito")}
              />
            </div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Legend-of-Hou-Yi_Icon_Rounded_1024.png"
        alt="Legend of Hou Yi"
        onClick={() => confirmGameOpen("1ed6fe92243975f73c944342119a1336", "Legend of Hou Yi")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Prosperity-Lion_Icon_Rounded_1024.png"
        alt="Prosperity Lion"
        onClick={() => confirmGameOpen("1fcb23fa9fac3ca32e20adfe90028de3", "Prosperity Lion")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Hip-Hop-Panda_Icon_Rounded_1024.png"
        alt="Hip Hop Panda"
        onClick={() => confirmGameOpen("5fdbd55ac67eea146b93939ee060cd54", "Hip Hop Panda")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Santas-Gift-Rush_Icon_Rounded_1024.png"
        alt="Santa's Gift Rush"
        onClick={() => confirmGameOpen("864edc20e589a738c632f8a49a2e02a3", "Santa's Gift Rush")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Baccarat-Deluxe_Icon_Rounded_1024.png"
        alt="Baccarat Deluxe"
        onClick={() => confirmGameOpen("22c3b8df172b40ac24a7e9c909e0e50e", "Baccarat Deluxe")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Gem-Saviour-Sword_rounded_1024.png"
        alt="Gem Saviour Sword"
        onClick={() => confirmGameOpen("4bbb563e9cf0211a3433beeebe70f35b", "Gem Saviour Sword")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Piggy-Gold_Icon_Rounded_1024.png"
        alt="Piggy Gold"
        onClick={() => confirmGameOpen("a9d874dd5305212b09845fc88f72e02d", "Piggy Gold")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Symbols-of-Egypt_Icon_Rounded_1024.png"
        alt="Symbols of Egypt"
        onClick={() => confirmGameOpen("0c7c636333c3c0807d2da26e1f0c8cd1", "Symbols of Egypt")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Emperors-Favour_Icon_Rounded_1024.png"
        alt="Emperor's Favour"
        onClick={() => confirmGameOpen("12766ca09f503fec11f391199fce5e24", "Emperor's Favour")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ganesha-Gold_rounded_1024.png"
        alt="Ganesha Gold"
        onClick={() => confirmGameOpen("8dcea650a5a4d96530a77e6df8f61923", "Ganesha Gold")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Jungle-Delight_Icon_Rounded_1024.png"
        alt="Jungle Delight"
        onClick={() => confirmGameOpen("232e8e0c74f9bb16ab676e5ed49d72b4", "Jungle Delight")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Journey-to-the-Wealth_Icon_Rounded_1024.png"
        alt="Journey to the Wealth"
        onClick={() => confirmGameOpen("139f7ae7151a8bd388511bd8b7ce0c40", "Journey to the Wealth")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Flirting-Scholar_rounded_1024.png"
        alt="Flirting Scholar"
        onClick={() => confirmGameOpen("0c884fde76cbc187f2797c4f76532220", "Flirting Scholar")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ninja-vs-Samurai_rounded_1024.png"
        alt="Ninja vs Samurai"
        onClick={() => confirmGameOpen("2eb712d4bb30e4594032ebf1464618b1", "Ninja vs Samurai")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Muay-Thai-Champion_rounded_1024.png"
        alt="Muay Thai Champion"
        onClick={() => confirmGameOpen("82127ece1232c6762c81fedb73c99756", "Muay Thai Champion")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Dragon-Tiger-Luck_rounded_1024.png"
        alt="Dragon Tiger Luck"
        onClick={() => confirmGameOpen("3d3dd6e2fd819832528108e0af197c43", "Dragon Tiger Luck")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fortune-Mouse_rounded_1024.png"
        alt="Fortune Mouse"
        onClick={() => confirmGameOpen("8e5a4dd7da06fb68165d13f8bcd06328", "Fortune Mouse")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Reel-Love_rounded_1024.png"
        alt="Reel Love"
        onClick={() => confirmGameOpen("813138051d990c0c21fb78015b14cbef", "Reel Love")}
    />
</div>

            <div>
              <img
                src="https://mediumrare.imgix.net/a77d914f12935f85ca574c3b52989b13cb48901ab8c55bdf326e1f2a177cbd97?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("e3f45e2f03388056aba660b7e737ecf0", "Sweet Bonanza 1000")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/2a83b2bfe89f30834cda26834e0715500c2c2885024069091fe7964ac3fa8adf?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("4ae52ed2e1a8c353878ba65ed7791ac4", "Gates of Olympus 1000")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/202834625f09f92dc0213a6f046d5111bcbba4aec9abf2d1b896839b592c657d?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("d3c7985229b2e4651fa7889445a5bfd8", "Aviamasters")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/c55c2ec37c310140617b75c9e490faca98090292991840dce959d93649efbfa5?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("784f4587c36ec560939eef1b85c639e4", "RIP City")}
              />
            </div>

            <div>
              <img
                src="https://mediumrare.imgix.net/d4c903b8aa3bcbcd3e7cfdd46e14fa5ff3f056922cd470a109438ee41184990e?w=180&h=236&fit=min&auto=format"
                alt="icon"
                onClick={() => confirmGameOpen("7e6130a781f047045e7b92638d8e3fca", "FRKN Bananas")}
              />
            </div>
          </div>

          <div className={[styles.homeAdditionalGamesTitle, viewBoxNumber != 7 ? styles.hideView : ""].join(" ")}>
            <span></span>
            <div className={[styles.headinggames]}>
            Fishing
              <div className={[styles.seeallbutton]}>
                {/* <div className={[styles.seealltext]}>See all     
            </div>
            <svg height="1em" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 2"><path d="M16.88 15.53 7 5.66a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path><path d="m26.46 15.53-9.88-9.87a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path></g></svg> */}
              </div>
            </div>
          </div>
          <div className={[styles.homeAdditionalGamesView, viewBoxNumber != 7 ? styles.hideView : ""].join(" ")}>
          <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Royal-Fishing.png"
            alt="icon"
            onClick={() => confirmGameOpen("e794bf5717aca371152df192341fe68b", "Royal Fishing")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bombing-Fishing.png"
            alt="icon"
            onClick={() => confirmGameOpen("e333695bcff28acdbecc641ae6ee2b23", "Bombing Fishing")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dinosaur-Tycoon.png"
            alt="icon"
            onClick={() => confirmGameOpen("eef3e28f0e3e7b72cbca61e7924d00f1", "Dinosaur Tycoon")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jackpot-Fishing.png"
            alt="icon"
            onClick={() => confirmGameOpen("3cf4a85cb6dcf4d8836c982c359cd72d", "Jackpot Fishing")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-Fortune.png"
            alt="icon"
            onClick={() => confirmGameOpen("1200b82493e4788d038849bca884d773", "Dragon Fortune")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mega-Fishing.png"
            alt="icon"
            onClick={() => confirmGameOpen("caacafe3f64a6279e10a378ede09ff38", "Mega Fishing")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Boom-Legend.png"
            alt="icon"
            onClick={() => confirmGameOpen("f02ede19c5953fce22c6098d860dadf4", "Boom Legend")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Happy-Fishing.png"
            alt="icon"
            onClick={() => confirmGameOpen("71c68a4ddb63bdc8488114a08e603f1c", "Happy Fishing")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/All-star-Fishing.png"
            alt="icon"
            onClick={() => confirmGameOpen("9ec2a18752f83e45ccedde8dfeb0f6a7", "All-star Fishing")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dinosaur-Tycoon-II.png"
            alt="icon"
            onClick={() => confirmGameOpen("bbae6016f79f3df74e453eda164c08a4", "Dinosaur Tycoon II")}
        />
    </div>
    <div>
        <img
            src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ocean-King-Jackpot.png"
            alt="icon"
            onClick={() => confirmGameOpen("564c48d53fcddd2bcf0bf3602d86c958", "Ocean King Jackpot")}
        />
    </div>

    <div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Happy-Fishing.png"
      alt="icon"
      onClick={() => confirmGameOpen("11055f0bc7f35b34bcfa966b529dba63", "Happy Fishing")}
    />
  </div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Mega-Fishing.png"
      alt="icon"
      onClick={() => confirmGameOpen("5b4c3acdabc8ac8f234d6864d2ee3a8a", "Mega Fishing")}
    />
  </div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/All-star-Fishing.png"
      alt="icon"
      onClick={() => confirmGameOpen("bb0c86c376c785e0133af2fe88faaadd", "All-star Fishing")}
    />
  </div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Boom-Legend.png"
      alt="icon"
      onClick={() => confirmGameOpen("fc537dbfab0fcfa7ade4bcb9210e78e0", "Boom Legend")}
    />
  </div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Dragon-Fortune.png"
      alt="icon"
      onClick={() => confirmGameOpen("5c35435c71eb4674e79b1cd8068ba430", "Dragon Fortune")}
    />
  </div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Dinosaur-Tycoon.png"
      alt="icon"
      onClick={() => confirmGameOpen("dff81bd0bba33f59adf64ca1ba80b63b", "Dinosaur Tycoon")}
    />
  </div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Jackpot-Fishing.png"
      alt="icon"
      onClick={() => confirmGameOpen("599dc6e567e3cf3bc75c19318812bdbb", "Jackpot Fishing")}
    />
  </div>
  <div>
    <img
      src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Bombing-Fishing.png"
      alt="icon"
      onClick={() => confirmGameOpen("386cd7d395614ff0e15e6c832211ecd1", "Bombing Fishing")}
    />
  </div>
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Master.png"
        alt="Dragon Master Icon"
        onClick={() => confirmGameOpen("f691d904ea681ce449263f7e9cc47c35", "Dragon Master")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fishing-Yilufa.png"
        alt="Fishing Yilufa Icon"
        onClick={() => confirmGameOpen("a877c97367d24925a11d342726eb0320f", "Fishing Yilufa")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Shade-Dragons-Fishing.png"
        alt="Shade Dragons Fishing Icon"
        onClick={() => confirmGameOpen("89e967a8336fb8caad2c1b6d735588fe", "Shade Dragons Fishing")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Cai-Shen-Fishing.png"
        alt="Cai Shen Fishing Icon"
        onClick={() => confirmGameOpen("6df463eabe5fcdaa033e1c89b9ffd162", "Cai Shen Fishing")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Fishing-Ii.png"
        alt="Dragon Fishing Ii Icon"
        onClick={() => confirmGameOpen("6cef8d8ea517d86602db60fe9781b01b", "Dragon Fishing Ii")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Fishing.png"
        alt="Dragon Fishing Icon"
        onClick={() => confirmGameOpen("1145d7cd96518a5ba2f77cb14cb363c4", "Dragon Fishing")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Happy-Fishing.png"
        alt="Happy Fishing Icon"
        onClick={() => confirmGameOpen("11055f0bc7f35b34bcfa966b529dba63", "Happy Fishing")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Mega-Fishing.png"
        alt="Mega Fishing Icon"
        onClick={() => confirmGameOpen("5b4c3acdabc8ac8f234d6864d2ee3a8a", "Mega Fishing")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/All-star-Fishing.png"
        alt="All-star Fishing Icon"
        onClick={() => confirmGameOpen("bb0c86c376c785e0133af2fe88faaadd", "All-star Fishing")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Boom-Legend.png"
        alt="Boom Legend Icon"
        onClick={() => confirmGameOpen("fc537dbfab0fcfa7ade4bcb9210e78e0", "Boom Legend")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Dragon-Fortune.png"
        alt="Dragon Fortune Icon"
        onClick={() => confirmGameOpen("5c35435c71eb4674e79b1cd8068ba430", "Dragon Fortune")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Dinosaur-Tycoon.png"
        alt="Dinosaur Tycoon Icon"
        onClick={() => confirmGameOpen("dff81bd0bba33f59adf64ca1ba80b63b", "Dinosaur Tycoon")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Jackpot-Fishing.png"
        alt="Jackpot Fishing Icon"
        onClick={() => confirmGameOpen("599dc6e567e3cf3bc75c19318812bdbb", "Jackpot Fishing")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/tada/Bombing-Fishing.png"
        alt="Bombing Fishing Icon"
        onClick={() => confirmGameOpen("386cd7d395614ff0e15e6c832211ecd1", "Bombing Fishing")}
    />
</div>
          </div>

          <div className={[styles.homeAdditionalGamesTitle, viewBoxNumber != 11 ? styles.hideView : ""].join(" ")}>
            <span></span>
            <div className={[styles.headinggames]}>
              Sports Game
              <div className={[styles.seeallbutton]}>
                {/* <div className={[styles.seealltext]}>See all     
            </div>
            <svg height="1em" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 2"><path d="M16.88 15.53 7 5.66a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path><path d="m26.46 15.53-9.88-9.87a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path></g></svg> */}
              </div>
            </div>
          </div>
          <div className={[styles.homeAdditionalGamesView, viewBoxNumber != 11 ? styles.hideView : ""].join(" ")}>
          <div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti.png"
        alt="Teen Patti Icon"
        onClick={() => confirmGameOpen("f743cb55c2c4b737727ef144413937f4", "Teen Patti")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/AK47.png"
        alt="AK47 Icon"
        onClick={() => confirmGameOpen("488c377662cad37a551bde18e2fbe785", "AK47")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Andar-Bahar.png"
        alt="Andar Bahar Icon"
        onClick={() => confirmGameOpen("6f48b3aa0b64c79a2dc320ea021148b5", "Andar Bahar")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Rummy.png"
        alt="Rummy Icon"
        onClick={() => confirmGameOpen("ae632f32c3a1e6803f9a6fbec16be28e", "Rummy")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak.png"
        alt="Callbreak Icon"
        onClick={() => confirmGameOpen("9092b5a56e001c60850c4c1184c53e07", "Callbreak")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-Joker.png"
        alt="Teen Patti Joker Icon"
        onClick={() => confirmGameOpen("1a4eaca67612e65fdcae43f4c8a667a4", "Teen Patti Joker")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak-Quick.png"
        alt="Callbreak Quick Icon"
        onClick={() => confirmGameOpen("aa9a9916d6e48ba50afa3c2246b6dacb", "Callbreak Quick")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-20-20.png"
        alt="Teen Patti 20-20 Icon"
        onClick={() => confirmGameOpen("1afa7db588d05de7b9abca4664542765", "Teen Patti 20-20")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ludo-Quick.png"
        alt="Ludo Quick Icon"
        onClick={() => confirmGameOpen("bb1f14d788d37b06dc8f6701ed57ed0d", "Ludo Quick")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Tongits-Go.png"
        alt="Tongits Go Icon"
        onClick={() => confirmGameOpen("26fbfab92a3837b7dbf767e783b173af", "Tongits Go")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pusoy-Go.png"
        alt="Pusoy Go Icon"
        onClick={() => confirmGameOpen("f2879a3f20f305eadad13448e11c052e", "Pusoy Go")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack.png"
        alt="Blackjack Icon"
        onClick={() => confirmGameOpen("3b502aee6c9e1ef0f698332ee1b76634", "Blackjack")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack-Lucky-Ladies.png"
        alt="Blackjack Lucky Ladies Icon"
        onClick={() => confirmGameOpen("d0d1c20062e28493e1750f27a1730c48", "Blackjack Lucky Ladies")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/MINI-FLUSH.png"
        alt="MINI FLUSH Icon"
        onClick={() => confirmGameOpen("07afefc388ab6af8cf26f85286f83fae", "MINI FLUSH")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pool-Rummy.png"
        alt="Pool Rummy Icon"
        onClick={() => confirmGameOpen("43e7df819bf57722a8917bb328640b30", "Pool Rummy")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Caribbean-Stud-Poker.png"
        alt="Caribbean Stud Poker Icon"
        onClick={() => confirmGameOpen("04c9784b0b1b162b2c86f9ce353da8b7", "Caribbean Stud Poker")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Caribbean Stud Poker.png"
        alt="Caribbean Stud Poker Icon"
        onClick={() => confirmGameOpen("724eebd5cbe7555b01ed60279cb59e5a", "Caribbean Stud Poker")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Triple Card Poker.png"
        alt="Triple Card Poker Icon"
        onClick={() => confirmGameOpen("b7c3b022f1c2b768524523d855a58d89", "Triple Card Poker")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Russian-Poker.png"
        alt="Russian Poker Icon"
        onClick={() => confirmGameOpen("31ee0411b49acf83932fa0519e676997", "Russian Poker")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Turkish-Blackjack-3.png"
        alt="Turkish Blackjack 3 Icon"
        onClick={() => confirmGameOpen("37b4f503301dd3fbbb0beb71b814452c9", "Turkish Blackjack 3")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Russian-Blackjack-2.png"
        alt="Russian Blackjack 2 Icon"
        onClick={() => confirmGameOpen("716e3dd6a3e560067425fec4951abe25", "Russian Blackjack 2")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Russian-Blackjack-1.png"
        alt="Russian Blackjack 1 Icon"
        onClick={() => confirmGameOpen("4244969212746e76beb92f71ba300114", "Russian Blackjack 1")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Turkish-Blackjack-2.png"
        alt="Turkish Blackjack 2 Icon"
        onClick={() => confirmGameOpen("25384176a2560a0a69c301b1c8cf83f9", "Turkish Blackjack 2")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Turkish-Blackjack-1.png"
        alt="Turkish Blackjack 1 Icon"
        onClick={() => confirmGameOpen("9e8ce809e74cc1ebda5ca59a927def6b", "Turkish Blackjack 1")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Rumba-Blackjack-4.png"
        alt="Rumba Blackjack 4 Icon"
        onClick={() => confirmGameOpen("1c77a06449c384b97f6239572ef87be3", "Rumba Blackjack 4")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Rumba-Blackjack-3.png"
        alt="Rumba Blackjack 3 Icon"
        onClick={() => confirmGameOpen("e6a2e3cc081f28298164d9197c38ec7c", "Rumba Blackjack 3")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Rumba-Blackjack-2.png"
        alt="Rumba Blackjack 2 Icon"
        onClick={() => confirmGameOpen("22c57f788355265137a61874d0b53bb9", "Rumba Blackjack 2")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Rumba-Blackjack-1.png"
        alt="Rumba Blackjack 1 Icon"
        onClick={() => confirmGameOpen("8ef17e9b4c5c67b7f43f4bced3c31a27", "Rumba Blackjack 1")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/VIP-Diamond-Blackjack.png"
        alt="VIP Diamond Blackjack Icon"
        onClick={() => confirmGameOpen("48420430ede7a5d7615dae19aa4463a7", "VIP Diamond Blackjack")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/Ezugi/Surrender-Blackjack.png"
        alt="Surrender Blackjack Icon"
        onClick={() => confirmGameOpen("d9723621d4007265d66cc115b5a953df", "Surrender Blackjack")}
    />
</div>
          </div>


          <div className={[styles.homeAdditionalGamesTitle, viewBoxNumber != 12 ? styles.hideView : ""].join(" ")}>
            <span></span>
            <div className={[styles.headinggames]}>
              Table Game
              <div className={[styles.seeallbutton]}>
                {/* <div className={[styles.seealltext]}>See all     
            </div>
            <svg height="1em" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 2"><path d="M16.88 15.53 7 5.66a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path><path d="m26.46 15.53-9.88-9.87a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path></g></svg> */}
              </div>
            </div>
          </div>
          <div className={[styles.homeAdditionalGamesView, viewBoxNumber != 12 ? styles.hideView : ""].join(" ")}>
          <div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Big-Small.png"
        alt="Big Small Icon"
        onClick={() => confirmGameOpen("25822eb4d6459cc8b39c4f7b69b1bf2c", "Big Small")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Number-King.png"
        alt="Number King Icon"
        onClick={() => confirmGameOpen("36d20c24669dca7630715f2e0a7c18be", "Number King")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Journey-West-M.png"
        alt="Journey West M Icon"
        onClick={() => confirmGameOpen("0d0a5a1731a6a05ffeb0e0f9d1948f80", "Journey West M")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/km/Game_KMQM_Bola_Tangkas_520x520.jpg"
        alt="Bola Tangkas Icon"
        onClick={() => confirmGameOpen("0d4f0e572ca817d40586e61c63b9b91e", "Bola Tangkas")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/km/Game_KMQM_KM_Power_Ball_343x200.jpg"
        alt="Bingo Rolle Icon"
        onClick={() => confirmGameOpen("98005ebb98642edb5704eba30493992", "Bingo Rolle")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/km/Game_KMQM_Color_Game_520x520.jpg"
        alt="Color Game Icon"
        onClick={() => confirmGameOpen("7247ea0c87f40313cc9f65171ba18051", "Color Game")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/km/Game_KMQM_KM_Marble_Knockout_520x520.jpg"
        alt="KM Marble Knockout Icon"
        onClick={() => confirmGameOpen("0712f896ec76df7c9fe70e4998bcfd10", "KM Marble Knockout")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/km/Game_KMQM_KM_Virtual_Hound_Racing_520x520.jpg"
        alt="KM Virtual Hound Racing Icon"
        onClick={() => confirmGameOpen("c6e9a9643ed0798a0c02175919a8b6d9", "KM Virtual Hound Racing")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Poker-King.png"
        alt="Poker King Icon"
        onClick={() => confirmGameOpen("a9b13010273fcb0284c9ef436c5fe2ff", "Poker King")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-&-Tiger.png"
        alt="Dragon & Tiger Icon"
        onClick={() => confirmGameOpen("e7ac92d2fdd2aedca92a3521b4416f47", "Dragon & Tiger")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/iRich-Bingo.png"
        alt="iRich Bingo Icon"
        onClick={() => confirmGameOpen("a53e46bf1e31f7a960ae314dc188e8b3", "iRich Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/7up7down.png"
        alt="7up7down Icon"
        onClick={() => confirmGameOpen("3aca3084a5c1a8c77c52d6147ee3d2ab", "7up7down")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Baccarat.png"
        alt="Baccarat Icon"
        onClick={() => confirmGameOpen("b9c7c5f589cdaa63c4495e69eaa6dbbf", "Baccarat")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Bingo.png"
        alt="Fortune Bingo Icon"
        onClick={() => confirmGameOpen("2fd70535a3c838a438b4b8003ecce49d", "Fortune Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sic-Bo.png"
        alt="Sic Bo Icon"
        onClick={() => confirmGameOpen("e0dc8a7fd369bd39a2d5747be87825c", "Sic Bo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Bingo.png"
        alt="Super Bingo Icon"
        onClick={() => confirmGameOpen("c934e67c2a84f52ef4fb598b56f3e7ba", "Super Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bingo-Carnaval.png"
        alt="Bingo Carnaval Icon"
        onClick={() => confirmGameOpen("d419ec9ab6a23590770fd77b036aed16", "Bingo Carnaval")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Win-Drop.png"
        alt="Win Drop Icon"
        onClick={() => confirmGameOpen("8211bc6e55e84d266bef9a6960940183", "Win Drop")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Bingo.png"
        alt="Lucky Bingo Icon"
        onClick={() => confirmGameOpen("c9f2470e285f3580cd761ba2e1f067e1", "Lucky Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jackpot-Bingo.png"
        alt="Jackpot Bingo Icon"
        onClick={() => confirmGameOpen("780d43c0a98bc8f6a0705976605608c3", "Jackpot Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Color-Game.png"
        alt="Color Game Icon"
        onClick={() => confirmGameOpen("2ac4917fbc8b2034307b0c3cdd90d416", "Color Game")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Color-Game.png"
        alt="Color Game Icon"
        onClick={() => confirmGameOpen("2ac4917fbc8b2034307b0c3cdd90d416", "Color Game")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Go-Goal-BIngo.png"
        alt="Go Goal BIngo Icon"
        onClick={() => confirmGameOpen("4e5ddaa644badc5f68974a65bf7af02a", "Go Goal BIngo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Calaca-Bingo.png"
        alt="Calaca Bingo Icon"
        onClick={() => confirmGameOpen("b2f05dae5370035a2675025953d1d115", "Calaca Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/PAPPU.png"
        alt="PAPPU Icon"
        onClick={() => confirmGameOpen("e5091890bbb65a5f9ceb657351fa73c1", "PAPPU")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/West-Hunter-Bingo.png"
        alt="West Hunter Bingo Icon"
        onClick={() => confirmGameOpen("8d2c1506dc4ae4c47d23f9359d71c360", "West Hunter Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bingo-Adventure.png"
        alt="Bingo Adventure Icon"
        onClick={() => confirmGameOpen("2303867628a9a62272da7576665bbc65", "Bingo Adventure")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Land.png"
        alt="Golden Land Icon"
        onClick={() => confirmGameOpen("05fc951a633d4c6b4bbe8c429cd63658", "Golden Land")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Candyland-Bingo.png"
        alt="Candyland Bingo Icon"
        onClick={() => confirmGameOpen("711acbdf297ce40a09dd0e9023b63f50", "Candyland Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Color-Prediction.png"
        alt="Color Prediction Icon"
        onClick={() => confirmGameOpen("4a64504353c2304a3061bfd31cd9a62e", "Color Prediction")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Magic-Lamp-Bingo.png"
        alt="Magic Lamp Bingo Icon"
        onClick={() => confirmGameOpen("848ac1703885d5a86b54fbbf094b3b63", "Magic Lamp Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pearls-of-Bingo.png"
        alt="Pearls of Bingo Icon"
        onClick={() => confirmGameOpen("0995142f4685f66dfdd1a54fffa66ffa", "Pearls of Bingo")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/European-Roulette.png"
        alt="European Roulette Icon"
        onClick={() => confirmGameOpen("d4fc911a31b3a61edd83bdd95e36f3bf", "European Roulette")}
    />
</div>
<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits-Fight.png"
        alt="Tongits Fight Icon"
        onClick={() => confirmGameOpen("6996a44ebff8fc97ce19cf791f4916cc", "Tongits Fight")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy-Rush.png"
        alt="Pusoy Rush Icon"
        onClick={() => confirmGameOpen("f03953d954b4ac3809efbedd5dfabec2", "Pusoy Rush")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dragon-Tiger-Joker-Bonus.png"
        alt="Dragon Tiger - Joker Bonus Icon"
        onClick={() => confirmGameOpen("067d540d7ece7e7dfcfcadf11f25a71d", "Dragon Tiger - Joker Bonus")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Tongits.png"
        alt="Tongits Icon"
        onClick={() => confirmGameOpen("47614f18718c2f911b89f00fd053b527", "Tongits")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Pusoy.png"
        alt="Pusoy Icon"
        onClick={() => confirmGameOpen("f436610d0255b4e3646603a1e42793b7", "Pusoy")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Fighter-Fire.png"
        alt="Fighter Fire Icon"
        onClick={() => confirmGameOpen("ff83699bef9b2e773857ed1a9eedc5fb", "Fighter Fire")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Dice.png"
        alt="Dice Icon"
        onClick={() => confirmGameOpen("6aa921aebc8d7e170740cfc8e88426f6", "Dice")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mole-Crash.png"
        alt="Mole Crash Icon"
        onClick={() => confirmGameOpen("a170eb308c8fab8f2a5cdac5b427acbd", "Mole Crash")}
    />
</div>

<div>
    <img
        src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jdb/Mines2.png"
        alt="Mines2 Icon"
        onClick={() => confirmGameOpen("b1ad7a48e4d4839dbe53fcadf7eb5183", "Mines2")}
    />
</div>
          </div>

          <div className={[styles.homeAdditionalGamesTitle, viewBoxNumber != 2 ? styles.hideView : ""].join(" ")}>
            <span></span>
            <div className={[styles.headinggames]}>
              Sports Game
              <div className={[styles.seeallbutton]}>
                {/* <div className={[styles.seealltext]}>See all     
            </div>
            <svg height="1em" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 2"><path d="M16.88 15.53 7 5.66a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path><path d="m26.46 15.53-9.88-9.87a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path></g></svg> */}
              </div>
            </div>
          </div>
          <div className={[styles.homeAdditionalGamesView, viewBoxNumber != 2 ? styles.hideView : ""].join(" ")}>
            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/vendorlogo/vendorlogo_20240814202959vsy1.png"
                alt="icon"
                onClick={() => confirmGameOpen("92b24e4c25107367a80e0fe1a97c24e4", "LuckSportGaming")}
              />
            </div>
            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/vendorlogo/vendorlogo_20240814202814ql4p.png"
                alt="icon"
                onClick={() => confirmGameOpen("08ced9dd788aed11ff3c7f387ae0f063", "SABA Sports")}
              />
            </div>
          </div>

          <div className={[styles.homeAdditionalGamesTitle, viewBoxNumber != 3 ? styles.hideView : ""].join(" ")}>
            <span></span>
            <div className={[styles.headinggames]}>
              Live Casion
              <div className={[styles.seeallbutton]}>
                {/* <div className={[styles.seealltext]}>See all     
            </div>
            <svg height="1em" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 2"><path d="M16.88 15.53 7 5.66a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path><path d="m26.46 15.53-9.88-9.87a1 1 0 0 0-1.41 1.41l9.06 9.06-8.8 8.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l9.62-9.61a.85.85 0 0 0 0-1.2Z" fill="#f2ca33" class="fill-231f20"></path></g></svg> */}
              </div>
            </div>
          </div>

          <div className={[styles.homeAdditionalGamesView, viewBoxNumber != 3 ? styles.hideView : ""].join(" ")}>
            <div>
              <img
                src="https://bc.imgix.net/game/image/97a368dcf8.png?_v=4&auto=format&dpr=1.125&w=200"
                alt="icon"
                onClick={() => confirmGameOpen("4e58131adb95bb061a40e6e309116c19", "Microgaming Lobby")}
              />
            </div>

            <div>
              <img
                src="https://bc.imgix.net/game/image/24d4df39d5.png?_v=4&auto=format&dpr=1.125&w=200"
                alt="icon"
                onClick={() => confirmGameOpen("d0e052b031dfcdb08d1803f4bcc618ef", "Ezugi Lobby")}
              />
            </div>

            <div>
              <img
                src="https://www.primeapi.com/cdn/gameRes/sq/350/PlaytechGameShowsLobby.jpg"
                alt="icon"
                onClick={() => confirmGameOpen("c38efc51028bd65f42396fa079c125d6", "Playtech Lobby")}
              />
            </div>

            <div>
              <img
                src="https://bc.imgix.net/game/image/9e20f4796d.png?_v=4&auto=format&dpr=1.125&w=200"
                alt="icon"
                onClick={() => confirmGameOpen("8ef39602e589bf9f32fc351b1cbb338b", "Evoluiton Lobby")}
              />
            </div>

            <div>
              <img
                src="https://bc.imgix.net/game/image/9225fb579c.png?_v=4&auto=format&dpr=2.625&w=100"
                alt="icon"
                onClick={() => confirmGameOpen("a1a01855da3f29d09a848e705ad76ea1", "Pragmatic play")}
              />
            </div>

            <div>
              <img
                src="https://bc.imgix.net/game/image/cbe377c8e7.png?_v=4&auto=format&dpr=1.125&w=200"
                alt="icon"
                onClick={() => confirmGameOpen("f7b98e899461bdd49f92afc36b4c0db5", "Super Andar Bahar")}
              />
            </div>

            <div>
              <img
                src="https://bc.imgix.net/game/image/211bf0ceb5.png?_v=4&auto=format&dpr=1.125&w=200"
                alt="icon"
                onClick={() => confirmGameOpen("394fe6a2cde24bc487767236cc6eccd6", "XXXtreme Lightning Roulette")}
              />
            </div>

            <div>
              <img
                src="https://bc.imgix.net/game/image/83ab13d3b8.png?_v=4&auto=format&dpr=1.125&w=200"
                alt="icon"
                onClick={() => confirmGameOpen("917c0c51d248c33eb058e3210a2e7371", "Crazy Time")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Lightning Baccarat.png"
                alt="First Person Lightning Baccarat"
                onClick={() => confirmGameOpen("fec1b730e804bf14bd471a1e9b82bf44", "First Person Lightning Baccarat")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Craps.png"
                alt="First Person Craps"
                onClick={() => confirmGameOpen("823245918aa2afd108a5912e363c083c", "First Person Craps")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Baccarat.png"
                alt="First Person Baccarat"
                onClick={() => confirmGameOpen("e18dfa4a5dd4a0f2d8b45337bd6abb9d", "First Person Baccarat")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Golden Wealth Baccarat.png"
                alt="First Person Golden Wealth Baccarat"
                onClick={() =>
                  confirmGameOpen("88e49e3fb9a9883f01f167d03f5efdcb", "First Person Golden Wealth Baccarat")
                }
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person American Roulette.png"
                alt="First Person American Roulette"
                onClick={() => confirmGameOpen("88b2d98462fbc45d6d31e95083e183df", "First Person American Roulette")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Deal or No Deal.png"
                alt="First Person Deal or No Deal"
                onClick={() => confirmGameOpen("c715eb06391fabe5275d0b56440f49f3", "First Person Deal or No Deal")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Blackjack.png"
                alt="First Person Blackjack"
                onClick={() => confirmGameOpen("4ac0e874a4d5fc55bcdba5302b43bc96", "First Person Blackjack")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Lightning Blackjack.png"
                alt="First Person Lightning Blackjack"
                onClick={() => confirmGameOpen("74914b065a9e6b9c7cb8a0e4b17294ed", "First Person Lightning Blackjack")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Roulette.png"
                alt="First Person Roulette"
                onClick={() => confirmGameOpen("a82670530f49a6b3445dc1a592a2eb9e", "First Person Roulette")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Dream Catcher.png"
                alt="Dream Catcher"
                onClick={() => confirmGameOpen("7f50a6fbfcd9257299303b5757d43525", "Dream Catcher")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Football Studio Dice.png"
                alt="Football Studio Dice"
                onClick={() => confirmGameOpen("1909b4e3380dc37654f8e3997e63ec1b", "Football Studio Dice")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Dead or Alive: Saloon.png"
                alt="Dead or Alive: Saloon"
                onClick={() => confirmGameOpen("eda1a2c5edb8370f8df58dcf8e1381b9", "Dead or Alive: Saloon")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/First Person Lightning Roulette.png"
                alt="First Person Lightning Roulette"
                onClick={() => confirmGameOpen("f5ee6fce16d369d1a656f3b227fc7236", "First Person Lightning Roulette")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Football Studio.png"
                alt="Football Studio"
                onClick={() => confirmGameOpen("392e13e38b3cec5ad259254a206d343a", "Football Studio")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Fan Tan.png"
                alt="Fan Tan"
                onClick={() => confirmGameOpen("5cb6aa4e2ce1c775c568561401ffdfca", "Fan Tan")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Speed Roulette.png"
                alt="Speed Roulette"
                onClick={() => confirmGameOpen("b4af506243cafae52908e8fa266f8ff6", "Speed Roulette")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Infinite Blackjack.png"
                alt="Infinite Blackjack"
                onClick={() => confirmGameOpen("58d7089aa20bce7f70e0e2ce81e888f4", "Infinite Blackjack")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/evoplay/Craps.png"
                alt="Craps"
                onClick={() => confirmGameOpen("689dd8e8f17dae910dba9fdd4990d41e", "Craps")}
              />
            </div>
          </div>
          <div id="minigames" className={[styles.homeAdditionalGamesTitle]}>
            <span></span>
            Mini
          </div>
          <div className={[styles.homeAdditionalGamesView]}>
            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/SPRIBE/22001.png"
                alt="icon"
                onClick={() => confirmGameOpen("a04d1f3eb8ccec8a4823bdf18e3f0e84", "Aviator")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/TB_Chess/102.png"
                alt="icon"
                onClick={() => confirmGameOpen("8a87aae7a3624d284306e9c6fe1b3e9c", "Dice")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/TB_Chess/105.png"
                alt="icon"
                onClick={() => confirmGameOpen("c68a515f0b3b10eec96cf6d33299f4e2", "Goal")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/SPRIBE/22006.png"
                alt="icon"
                onClick={() => confirmGameOpen("a669c993b0e1f1b7da100fcf95516bdf", "Hi Lo")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/TB_Chess/107.png"
                alt="icon"
                onClick={() => confirmGameOpen("b31720b3cd65d917a1a96ef61a72b672", "Hotline")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/TB_Chess/106.png"
                alt="icon"
                onClick={() => confirmGameOpen("c311eb4bbba03b105d150504931f2479", "Keno")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/SPRIBE/22005.png"
                alt="icon"
                onClick={() => confirmGameOpen("5c4a12fb0a9b296d9b0d5f9e1cd41d65", "Mines")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/TB_Chess/104.png"
                alt="icon"
                onClick={() => confirmGameOpen("9dc7ac6155c5a19c1cc204853e426367", "Mini Roulette")}
              />
            </div>

            <div>
              <img
                src="https://ossimg.tirangaagent.com/Tiranga/gamelogo/SPRIBE/22004.png"
                alt="icon"
                onClick={() => confirmGameOpen("6ab7a4fe5161936012d6b06143918223", "Plinko")}
              />
            </div>
            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Go-Rush.png"
                alt="Go Rush"
                onClick={() => confirmGameOpen("ef29b5eda8e2eaf721d7315491c51dCrash", "Go Rush")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mines.png"
                alt="Mines"
                onClick={() => confirmGameOpen("72ce7e04ce95ee94eef172c0dfd6dc17", "Mines")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Tower.png"
                alt="Tower"
                onClick={() => confirmGameOpen("8e939551b9e785001fcb5b0a32f88aba", "Tower")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/HILO.png"
                alt="HILO"
                onClick={() => confirmGameOpen("bd8a2bb2dd63503b93cf6ac9492786ce", "HILO")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Limbo.png"
                alt="Limbo"
                onClick={() => confirmGameOpen("eabf08253165b6bb2646e403de625d1a", "Limbo")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wheel.png"
                alt="Wheel"
                onClick={() => confirmGameOpen("6e19e03c50f035ddd9ffd804c30f8c80", "Wheel")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mines-Gold.png"
                alt="Mines Gold"
                onClick={() => confirmGameOpen("4bceeb28b1a88c87d1ef518d7af2bba9", "Mines Gold")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Keno.png"
                alt="Keno"
                onClick={() => confirmGameOpen("a54e3f5e231085c7d8ba99e8ed2261fc", "Keno")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Plinko.png"
                alt="Plinko"
                onClick={() => confirmGameOpen("e3b71c6844eb8c30f5ef210ad92725a6", "Plinko")}
              />
            </div>

            <div>
              <img
                src="https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crash-Bonus.png"
                alt="Crash Bonus"
                onClick={() => confirmGameOpen("a7f3e5f210523a989a7c6b32f2f1ad42", "Crash Bonus")}
              />
            </div>
          </div>

          <div className="min-h pd-15 mg-t-20 mg-b-10em">
            <span className={[general.colorWhite]}>Top Earner's List</span>

            <div className="col-view">{pageConst.winnersRecordList}</div>
          </div>
        </div>

        <BottomNavbar activeBar="home" />
      </div>
    </div>
  )
}

export default Home

